"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
var Application;
(function (Application) {
    Application["inventory"] = "inventory";
})(Application = exports.Application || (exports.Application = {}));
;
//# sourceMappingURL=Application.js.map